enum UxBrandTextEnum {
  EDGENUITY = "Edgenuity",
  IMAGINELEARNING = "IMAGINELEARNING",
  IMAGINEMYPATH = "IMAGINEMYPATH"
}
export default UxBrandTextEnum;
